import React, { useState, useEffect } from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse, Image } from "antd";
import { connect } from "react-redux";
import { FormatDateTime } from "../../../utility/format";
import MapFixedProblem from "./fix_problem_map_detail";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { setFixProblemPic } from "../../../../actions/fixProblemPicAction";
import Cookies from "js-cookie";
import ApproveProcessLog from "../../../approve_process/approve_process_log";

const { Panel } = Collapse;
function Fix_Problem_Acceptance_Detail({
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  masterLang,
  factUpdate,
}) {
  const locale = Cookies.get("locale");
  const [acceptanceList, setacceptanceList] = useState({});
  const [callApiSuccess, setcallApiSuccess] = useState(true);
  const [showData, setshowData] = useState(false);
  const [currebtJobFixProblemId, setcurrebtJobFixProblemId] = useState(0);
  const { fixProblemPic } = useSelector((state) => ({
    fixProblemPic: state.fixProblemPic.fixProblemPic,
  }));
  const dispatch = useDispatch();
  useEffect(() => {
    Api.post("job_detail/get_jobfixproblem_list", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_id: headerdata?.job_id,
    }).then((res) => {
      if (res.data.result?.code === "P") {
        dispatch(setFixProblemPic(res.data.data?.result_oper_pic));
        if (res.data.data?.job_fixproblem_List.length > 0) {
          const firstRes = res.data.data.job_fixproblem_List[0];
          setcurrebtJobFixProblemId(firstRes.job_FixProblem_id);
          Api.post("job_detail/get_oper_job_fixproblem_acceptance_list", {
            company_id: CompanyId,
            operator_id: OperatorId,
            project_id: ProjectId,
            job_id: headerdata?.job_id,
            job_FixProblem_id: firstRes.job_FixProblem_id,
          }).then((res) => {
            const { result, data } = res.data;
            if (result.code === "P") {
              if (data !== undefined && data.length > 0) {
                const acceptanceData = res.data.data[0];
                setacceptanceList({
                  ...acceptanceData,
                  jobInServiceTime: acceptanceData.in_service_time,
                  maintainType: acceptanceData.maintain_type_id,
                  problemDetail: acceptanceData.fixProblem_detail,
                  actionDetail: acceptanceData.action_detail,
                  approveDetail: acceptanceData.accept_detail,
                });
                setshowData(true);
                setTimeout(() => {
                  setcallApiSuccess(true);
                }, 6000);
              } else {
                setshowData(false);
              }
            }
          });
        }
      }
    });
  }, []);

  return (
    <>
      {callApiSuccess ? (
        showData ? (
          <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
            <Panel header={<h4>รายละเอียดการตรวจรับงาน</h4>} key="1">
              <div className="d-flex align-content-md-start flex-wrap w-100">
                <div className="col-12">
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      In Service Time
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      <FormatDateTime
                        text={acceptanceList.jobInServiceTime}
                      ></FormatDateTime>
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      ประเภทงานซ่อม
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.maintain_name}
                    </span>
                  </div>
                  {/* ownerNetwork */}
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      Owner Network
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.owner_network_name}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      Group Cause
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.cause_name}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      Sub Cause
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.subCause_Desc1}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      {factUpdate
                        ? masterLang[locale]["cause_delay"]
                        : "Cause Delay"}
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList?.detail_Cause_Delay ?? "-"}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      รายละเอียดสำหรับ UIH
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.problemDetail}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      รายละเอียดการแก้ไข
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.actionDetail}
                    </span>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      รายละเอียดสำหรับลูกค้า
                    </span>
                    <span className="col-12 col-sm-8 content-text">
                      {acceptanceList.approveDetail}
                    </span>
                  </div>
                  <div className="row">
                    <MapFixedProblem
                      CompanyId={CompanyId}
                      OperatorId={OperatorId}
                      ProjectId={ProjectId}
                      headerdata={headerdata}
                      showHeader={false}
                    ></MapFixedProblem>
                  </div>
                  <div className="row">
                    <span className="col-12 col-sm-4 content-label">
                      ภาพประกอบการปิดงาน
                    </span>
                    <div className="col-12 col-sm-8 content-text">
                      <div className="mr-4" style={{ cursor: "pointer" }}>
                        <Image.PreviewGroup>
                          {fixProblemPic
                            .filter(
                              (s) =>
                                s.reference_id === currebtJobFixProblemId &&
                                s.pic_type === "F"
                            )
                            .map((m, i) => (
                              <Image
                                key={`operjob_pic_acceptance${i}`}
                                width={150}
                                height={80}
                                src={Api.checkPath(
                                  m.pic_url_path,
                                  m.pic_upload_name
                                )}
                              ></Image>
                            ))}
                        </Image.PreviewGroup>
                      </div>
                    </div>
                  </div>
                  {acceptanceList.approve_id ? (
                    <div className="row">
                      <ApproveProcessLog
                        header="UIH ตรวจรับงาน"
                        sendData={{ approve_id: acceptanceList.approve_id }}
                      ></ApproveProcessLog>
                    </div>
                  ) : null}
                </div>
              </div>
            </Panel>
          </Collapse>
        ) : (
          <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
            <Panel header={<h4>รายละเอียดการตรวจรับงาน</h4>} key="1">
              {/* <div className="row">
                <span className="col-12 content-text">
                  ไม่พบข้อมูลรายละเอียดสาเหตุ
                </span>
              </div> */}
              <Skeleton height={400}></Skeleton>
            </Panel>
          </Collapse>
        )
      ) : (
        <div
          style={{
            width: "96%",
            marginLeft: "2%",
            marginTop: "1%",
            height: "400px",
          }}
        >
          <Skeleton count={1} height={400} />
        </div>
      )}
    </>
  );
}
const mapStateToProps = (state) => ({
  masterLang: state.masterLang.masterLang,
  factUpdate: state.masterLang.factUpdate,
});
export default connect(mapStateToProps)(Fix_Problem_Acceptance_Detail);
